module.exports = __webpack_public_path__ + "static/img/3.ab991b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userMethods/3.png
// module id = /Ds2
// module chunks = 0